import { ErpForeignContryValue, ErpTransportationValue }
    from '../../shared/model/travelmanagement-values';
import { getDate } from 'app/rm/erp/common/utils/date-utils';

export interface TravelAbroadBackend {
    id?: number;
    readonly objGuid?: string;
    readonly lockVersion?: number;

    travelDay?: string;
    tripBeginDate?: number;
    tripEndDate?: number;

    travelItineraryFromSelected?: ErpForeignContryValue;
    destinationFrom?: string;
    travelItineraryToSelected?: ErpForeignContryValue;
    destinationTo?: string;

    transportationSelected?: ErpTransportationValue;

    note?: string;
}

export class TravelAbroad {
    id?: number;
    readonly objGuid?: string;
    readonly lockVersion?: number;

    travelDay?: string;
    tripBeginDate?: Date;
    tripEndDate?: Date;

    travelItineraryFromSelected?: ErpForeignContryValue;
    destinationFrom?: string;
    travelItineraryToSelected?: ErpForeignContryValue;
    destinationTo?: string;

    transportationSelected?: ErpTransportationValue;

    note?: string;
}

export class TravelAbroadFactory {
    static createFromBackendModel( backendModel: TravelAbroadBackend ): TravelAbroad {
        const frontendModel: TravelAbroad = {
            id: backendModel.id,
            objGuid: backendModel.objGuid,
            lockVersion: backendModel.lockVersion,

            travelDay: backendModel.travelDay,
            tripBeginDate: getDate( backendModel.tripBeginDate ),
            tripEndDate: getDate( backendModel.tripEndDate ),

            travelItineraryFromSelected: backendModel.travelItineraryFromSelected,
            destinationFrom: backendModel.destinationFrom,
            travelItineraryToSelected: backendModel.travelItineraryToSelected,
            destinationTo: backendModel.destinationTo,

            transportationSelected: backendModel.transportationSelected,

            note: backendModel.note,
        };
        return frontendModel;
    }

    static createFromFrontendModel( frontendModel: TravelAbroad ): TravelAbroadBackend {
        const backendModel: TravelAbroadBackend = {
            id: frontendModel.id,
            objGuid: frontendModel.objGuid,
            lockVersion: frontendModel.lockVersion,

            travelDay: frontendModel.travelDay,
            tripBeginDate: frontendModel.tripBeginDate?.getTime(),
            tripEndDate: frontendModel.tripEndDate?.getTime(),

            travelItineraryFromSelected: frontendModel.travelItineraryFromSelected,
            destinationFrom: frontendModel.destinationFrom,
            travelItineraryToSelected: frontendModel.travelItineraryToSelected,
            destinationTo: frontendModel.destinationTo,

            transportationSelected: frontendModel.transportationSelected,

            note: frontendModel.note,
        };
        return backendModel;
    }
}
